/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerGetItemRerunStatusQueryResponse, ApplicationsControllerGetItemRerunStatusPathParams, ApplicationsControllerGetItemRerunStatus400, ApplicationsControllerGetItemRerunStatus401, ApplicationsControllerGetItemRerunStatus403, ApplicationsControllerGetItemRerunStatus404 } from "../../models/checklistsController/ApplicationsControllerGetItemRerunStatus";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { applicationsControllerGetItemRerunStatus } from "../../clients/checklistsService/applicationsControllerGetItemRerunStatus";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const applicationsControllerGetItemRerunStatusQueryKey = (id: ApplicationsControllerGetItemRerunStatusPathParams["id"]) => [{
  url: '/api/v1/checklist-applications/:id/item-rerun',
  params: {
    id: id
  }
}] as const;
export type ApplicationsControllerGetItemRerunStatusQueryKey = ReturnType<typeof applicationsControllerGetItemRerunStatusQueryKey>;
export function applicationsControllerGetItemRerunStatusQueryOptions(id: ApplicationsControllerGetItemRerunStatusPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = applicationsControllerGetItemRerunStatusQueryKey(id);
  return queryOptions<ApplicationsControllerGetItemRerunStatusQueryResponse, ResponseErrorConfig<ApplicationsControllerGetItemRerunStatus400 | ApplicationsControllerGetItemRerunStatus401 | ApplicationsControllerGetItemRerunStatus403 | ApplicationsControllerGetItemRerunStatus404>, ApplicationsControllerGetItemRerunStatusQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return applicationsControllerGetItemRerunStatus(id, config);
    }
  });
}

/**
 * @description Reports why a whole-application rerun or a section, question or subquestion rerun is blocked. Requires the custom-reviews-playbooks flag for the organization.
 * @summary Whether the caller can rerun this application or its individual items
 * {@link /api/v1/checklist-applications/:id/item-rerun}
 */
export function useApplicationsControllerGetItemRerunStatus<TData = ApplicationsControllerGetItemRerunStatusQueryResponse, TQueryData = ApplicationsControllerGetItemRerunStatusQueryResponse, TQueryKey extends QueryKey = ApplicationsControllerGetItemRerunStatusQueryKey>(id: ApplicationsControllerGetItemRerunStatusPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<ApplicationsControllerGetItemRerunStatusQueryResponse, ResponseErrorConfig<ApplicationsControllerGetItemRerunStatus400 | ApplicationsControllerGetItemRerunStatus401 | ApplicationsControllerGetItemRerunStatus403 | ApplicationsControllerGetItemRerunStatus404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? applicationsControllerGetItemRerunStatusQueryKey(id);
  const query = useQuery({
    ...applicationsControllerGetItemRerunStatusQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ApplicationsControllerGetItemRerunStatus400 | ApplicationsControllerGetItemRerunStatus401 | ApplicationsControllerGetItemRerunStatus403 | ApplicationsControllerGetItemRerunStatus404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}